(function(window, angular) {
  "use strict";

	angular.module('service')
	.factory('conversationService', ['baseService', '$http', function(baseService, $http) {
		// inherits
		var extended = angular.copy(baseService);
		// url
		extended.base_url = getFullUrl('/api/conversation');

		/**
		 * send a new message
		 * @param  {object} conversation Conversation instance
		 * @param  {object} message      {text:'you string message'}
		 * @return {object}              message with ids, etc...
		 */
		extended.sendMessage = function(conversation, message) {
			return $http({
				method: 'POST',
				url: this.base_url + '/' + conversation.id + '/message',
				data: message
			}).then( function(response) {
				return angular.extend(message, response.data);
			});
		}

		/**
		 * get messages
		 * @param  {object} conversation Conversation instance
		 * @return {object}              messages with ids, etc...
		 */
		extended.searchMessages = function(conversation) {
			var this_instance = this;

			return $http({
				method: 'GET',
				url: this.base_url + '/' + conversation.id + '/message'
			}).then( function(response) {
				var messages = response.data;
				angular.forEach(messages, function(message, idx) {
					this_instance.initObj(message);
				});
				return messages;
			});
		}

		/**
		 * ack messages
		 * @param  {object} conversation Conversation instance
		 * @return {object}              messages with ids, etc...
		 */
		extended.markAsRead = function(conversation) {
			return $http({
				method: 'GET',
				url: this.base_url + '/' + conversation.id + '/mark_as_read'
			}).then( function(response) {
				conversation.total_unread_messages = 0;
				return conversation;
			});
		}

		return extended;
	}]);
})(window, window.angular);
